import en from './en/main.json'
import cn from './zh/main.json'
import ind from './id/main.json'
import kr from './ko/main.json'
import ru from './ru/main.json'
import tr from './tr/main.json'
import vi from './vi/main.json'
import es from './es/main.json'

export default {
  cn,
  en,
  in: ind,
  kr,
  ru,
  tr,
  vn: vi,
  es,
}
